import { IsDate, IsNotEmpty } from 'class-validator';

export class ExitResidentDto {
  @IsDate()
  @IsNotEmpty()
  exitDate!: Date;
}
